import { defineStore } from 'pinia';
import { workflowApiService } from 'src/services';
import type { dynamicObj } from 'src/pages/assets';
import { i18n } from 'src/boot/i18n';

interface WorkflowResponse {
  entries: any[];
}

export const useWorkflowsStore = defineStore('workflow', {
  state: () => ({
    workflow_list: [] as any,
    workflow_data: {} as dynamicObj,
    workflow_loading: false,
    fetch_workflow: false,
    searchBy: '',
  }),
  actions: {
    async getWorkflows(make_list = false) {
      try {
        if (this.fetch_workflow) {
          return;
        }

        this.workflow_loading = true;
        this.workflow_list = [];
        const response = (await workflowApiService.getWorkflows(
          this.searchBy,
        )) as WorkflowResponse;
        this.fetch_workflow = true;
        if (!response) {
          throw response;
        }

        if (response.hasOwnProperty('entries') && response.entries.length > 0) {
          this.workflow_data = response.entries;
        }

        if (make_list) {
          this.convertWorkflowToDropdown();
        }
      } catch (err) {
        logError(err);
      } finally {
        this.workflow_loading = false;
      }
    },

    convertWorkflowToDropdown() {
      this.workflow_list = [];
      if (
        this.workflow_data.length === 0 ||
        Object.keys(this.workflow_data).length === 0
      ) {
        return;
      }

      this.workflow_data.forEach((workflow: any) => {
        this.workflow_list.push({
          label: workflow.name,
          value: workflow.id,
        });
      });
    },
  },
});
